import type { RelationType, ActivityRelationSettings } from '@/types'

import type { ActivityLinkTarget } from './ActivityLinkTarget'

export class Relation<
  T extends ActivityLinkTarget,
  S extends ActivityRelationSettings = ActivityRelationSettings
> {
  constructor(
    public readonly id: number,
    public readonly left: T,
    public readonly right: T,
    public readonly type: RelationType,
    public readonly settings: S
  ) {}
}
